import { BasketAddItemOptions, BasketAmendItemOptions, BasketResponse } from 'types/BasketTypes';
import { waitForODMReady } from 'utilities/basket/basketUtilities';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import adaptBasketResponse from '../adaptors/adaptBasketResponse';

export default class ODMBasketService implements BasketServiceInterface {
  async addItem({ item }: BasketAddItemOptions): Promise<BasketResponse> {
    await waitForODMReady('odm', 'addItem');

    if (!window.ODM?.basket?.addItem) {
      throw new Error('ODM basket service is not available.');
    }

    const response = await window.ODM.basket.addItem(item);

    return adaptBasketResponse({
      data: response?.data,
      error: response?.error,
      status: response.status,
    });
  }

  async amendItem({ lineItem, item }: BasketAmendItemOptions): Promise<BasketResponse> {
    if (!lineItem || typeof lineItem !== 'string') {
      throw new Error('Line item is required to amend an item in the basket.');
    }

    await waitForODMReady('odm', 'amendItem');

    if (!window.ODM?.basket?.amendItem) {
      throw new Error('ODM basket service is not available.');
    }

    const response = await window.ODM.basket.amendItem(lineItem, item);

    return adaptBasketResponse({
      data: response?.data,
      error: response?.error,
      status: response.status,
    });
  }
}
